import React, { useState, useEffect, useCallback } from "react";
import { QueueType, useGenerator } from "@/app/context/GeneratorContext";
import QueueTypeBadge from "../queueTypeBadge";

export default function CountdownTimerFree({ translations }: { translations: any }) {
  const { activeJob } = useGenerator();

  const calculateTimeLeft = useCallback(() => {
    if (!activeJob?.delayedUntil) return 0;
    const now = new Date();
    const delayedUntil = new Date(activeJob.delayedUntil);
    const difference = delayedUntil.getTime() - now.getTime();
    return Math.max(0, Math.floor(difference / 1000));
  }, [activeJob?.delayedUntil]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(intervalId);
  }, [activeJob?.delayedUntil]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <>
      <QueueTypeBadge queueType={QueueType.Free} translations={translations} />
      <div className="ml-1">
        {translations.timeLeft}:{" "}
        {timeLeft > 0
          ? `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`
          : translations.queuePositionPending}
      </div>
    </>
  );
}
